/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectApproveProjectByConsultativePatch } from '../fn/project/api-project-approve-project-by-consultative-patch';
import { ApiProjectApproveProjectByConsultativePatch$Params } from '../fn/project/api-project-approve-project-by-consultative-patch';
import { apiProjectApproveProjectByConsultativePatch$Plain } from '../fn/project/api-project-approve-project-by-consultative-patch-plain';
import { ApiProjectApproveProjectByConsultativePatch$Plain$Params } from '../fn/project/api-project-approve-project-by-consultative-patch-plain';
import { apiProjectApproveProjectByManagerPatch } from '../fn/project/api-project-approve-project-by-manager-patch';
import { ApiProjectApproveProjectByManagerPatch$Params } from '../fn/project/api-project-approve-project-by-manager-patch';
import { apiProjectApproveProjectByManagerPatch$Plain } from '../fn/project/api-project-approve-project-by-manager-patch-plain';
import { ApiProjectApproveProjectByManagerPatch$Plain$Params } from '../fn/project/api-project-approve-project-by-manager-patch-plain';
import { apiProjectApproveProjectItemsPatch } from '../fn/project/api-project-approve-project-items-patch';
import { ApiProjectApproveProjectItemsPatch$Params } from '../fn/project/api-project-approve-project-items-patch';
import { apiProjectApproveProjectItemsPatch$Plain } from '../fn/project/api-project-approve-project-items-patch-plain';
import { ApiProjectApproveProjectItemsPatch$Plain$Params } from '../fn/project/api-project-approve-project-items-patch-plain';
import { apiProjectApproveProjectTasksPatch } from '../fn/project/api-project-approve-project-tasks-patch';
import { ApiProjectApproveProjectTasksPatch$Params } from '../fn/project/api-project-approve-project-tasks-patch';
import { apiProjectApproveProjectTasksPatch$Plain } from '../fn/project/api-project-approve-project-tasks-patch-plain';
import { ApiProjectApproveProjectTasksPatch$Plain$Params } from '../fn/project/api-project-approve-project-tasks-patch-plain';
import { apiProjectAssignProjectToProgramPost } from '../fn/project/api-project-assign-project-to-program-post';
import { ApiProjectAssignProjectToProgramPost$Params } from '../fn/project/api-project-assign-project-to-program-post';
import { apiProjectAssignProjectToProgramPost$Plain } from '../fn/project/api-project-assign-project-to-program-post-plain';
import { ApiProjectAssignProjectToProgramPost$Plain$Params } from '../fn/project/api-project-assign-project-to-program-post-plain';
import { apiProjectCreateProjectPost } from '../fn/project/api-project-create-project-post';
import { ApiProjectCreateProjectPost$Params } from '../fn/project/api-project-create-project-post';
import { apiProjectCreateProjectPost$Plain } from '../fn/project/api-project-create-project-post-plain';
import { ApiProjectCreateProjectPost$Plain$Params } from '../fn/project/api-project-create-project-post-plain';
import { apiProjectDeleteProjectDelete } from '../fn/project/api-project-delete-project-delete';
import { ApiProjectDeleteProjectDelete$Params } from '../fn/project/api-project-delete-project-delete';
import { apiProjectDeleteProjectDelete$Plain } from '../fn/project/api-project-delete-project-delete-plain';
import { ApiProjectDeleteProjectDelete$Plain$Params } from '../fn/project/api-project-delete-project-delete-plain';
import { apiProjectGetAllProjectsPost } from '../fn/project/api-project-get-all-projects-post';
import { ApiProjectGetAllProjectsPost$Params } from '../fn/project/api-project-get-all-projects-post';
import { apiProjectGetAllProjectsPost$Plain } from '../fn/project/api-project-get-all-projects-post-plain';
import { ApiProjectGetAllProjectsPost$Plain$Params } from '../fn/project/api-project-get-all-projects-post-plain';
import { apiProjectGetCurrentUserProjectsPost } from '../fn/project/api-project-get-current-user-projects-post';
import { ApiProjectGetCurrentUserProjectsPost$Params } from '../fn/project/api-project-get-current-user-projects-post';
import { apiProjectGetCurrentUserProjectsPost$Plain } from '../fn/project/api-project-get-current-user-projects-post-plain';
import { ApiProjectGetCurrentUserProjectsPost$Plain$Params } from '../fn/project/api-project-get-current-user-projects-post-plain';
import { apiProjectGetLaunchedProjectsPost } from '../fn/project/api-project-get-launched-projects-post';
import { ApiProjectGetLaunchedProjectsPost$Params } from '../fn/project/api-project-get-launched-projects-post';
import { apiProjectGetLaunchedProjectsPost$Plain } from '../fn/project/api-project-get-launched-projects-post-plain';
import { ApiProjectGetLaunchedProjectsPost$Plain$Params } from '../fn/project/api-project-get-launched-projects-post-plain';
import { apiProjectGetNotLaunchedProjectsPost } from '../fn/project/api-project-get-not-launched-projects-post';
import { ApiProjectGetNotLaunchedProjectsPost$Params } from '../fn/project/api-project-get-not-launched-projects-post';
import { apiProjectGetNotLaunchedProjectsPost$Plain } from '../fn/project/api-project-get-not-launched-projects-post-plain';
import { ApiProjectGetNotLaunchedProjectsPost$Plain$Params } from '../fn/project/api-project-get-not-launched-projects-post-plain';
import { apiProjectGetProjectGet } from '../fn/project/api-project-get-project-get';
import { ApiProjectGetProjectGet$Params } from '../fn/project/api-project-get-project-get';
import { apiProjectGetProjectGet$Plain } from '../fn/project/api-project-get-project-get-plain';
import { ApiProjectGetProjectGet$Plain$Params } from '../fn/project/api-project-get-project-get-plain';
import { apiProjectGetQuartersPost } from '../fn/project/api-project-get-quarters-post';
import { ApiProjectGetQuartersPost$Params } from '../fn/project/api-project-get-quarters-post';
import { apiProjectGetQuartersPost$Plain } from '../fn/project/api-project-get-quarters-post-plain';
import { ApiProjectGetQuartersPost$Plain$Params } from '../fn/project/api-project-get-quarters-post-plain';
import { apiProjectGetUserProjectsCardsPost } from '../fn/project/api-project-get-user-projects-cards-post';
import { ApiProjectGetUserProjectsCardsPost$Params } from '../fn/project/api-project-get-user-projects-cards-post';
import { apiProjectGetUserProjectsCardsPost$Plain } from '../fn/project/api-project-get-user-projects-cards-post-plain';
import { ApiProjectGetUserProjectsCardsPost$Plain$Params } from '../fn/project/api-project-get-user-projects-cards-post-plain';
import { apiProjectGetUserProjectsPost } from '../fn/project/api-project-get-user-projects-post';
import { ApiProjectGetUserProjectsPost$Params } from '../fn/project/api-project-get-user-projects-post';
import { apiProjectGetUserProjectsPost$Plain } from '../fn/project/api-project-get-user-projects-post-plain';
import { ApiProjectGetUserProjectsPost$Plain$Params } from '../fn/project/api-project-get-user-projects-post-plain';
import { apiProjectUnAssignProjectFromProgramPost } from '../fn/project/api-project-un-assign-project-from-program-post';
import { ApiProjectUnAssignProjectFromProgramPost$Params } from '../fn/project/api-project-un-assign-project-from-program-post';
import { apiProjectUnAssignProjectFromProgramPost$Plain } from '../fn/project/api-project-un-assign-project-from-program-post-plain';
import { ApiProjectUnAssignProjectFromProgramPost$Plain$Params } from '../fn/project/api-project-un-assign-project-from-program-post-plain';
import { apiProjectUpdateProjectPatch } from '../fn/project/api-project-update-project-patch';
import { ApiProjectUpdateProjectPatch$Params } from '../fn/project/api-project-update-project-patch';
import { apiProjectUpdateProjectPatch$Plain } from '../fn/project/api-project-update-project-patch-plain';
import { ApiProjectUpdateProjectPatch$Plain$Params } from '../fn/project/api-project-update-project-patch-plain';
import { apiProjectUpdateProjectQuarterPatch } from '../fn/project/api-project-update-project-quarter-patch';
import { ApiProjectUpdateProjectQuarterPatch$Params } from '../fn/project/api-project-update-project-quarter-patch';
import { apiProjectUpdateProjectQuarterPatch$Plain } from '../fn/project/api-project-update-project-quarter-patch-plain';
import { ApiProjectUpdateProjectQuarterPatch$Plain$Params } from '../fn/project/api-project-update-project-quarter-patch-plain';
import { ApproveProjectByConsultativeCommandResult } from '../models/approve-project-by-consultative-command-result';
import { ApproveProjectCommandResult } from '../models/approve-project-command-result';
import { ApproveProjectItemsCommandResult } from '../models/approve-project-items-command-result';
import { ApproveProjectTasksCommandResult } from '../models/approve-project-tasks-command-result';
import { AssignProjectToProgramCommandResult } from '../models/assign-project-to-program-command-result';
import { CreateProjectCommandResult } from '../models/create-project-command-result';
import { DeleteProjectCommandResult } from '../models/delete-project-command-result';
import { GetLaunchedProjectsQueryResult } from '../models/get-launched-projects-query-result';
import { GetNotLaunchedProjectsQueryResult } from '../models/get-not-launched-projects-query-result';
import { GetProjectQueryResult } from '../models/get-project-query-result';
import { GetProjectsQueryResult } from '../models/get-projects-query-result';
import { GetQuartersQueryResult } from '../models/get-quarters-query-result';
import { GetUserProjectsCardsQueryResult } from '../models/get-user-projects-cards-query-result';
import { GetUserProjectsQueryResult } from '../models/get-user-projects-query-result';
import { UnAssignProjectFromProgramCommandResult } from '../models/un-assign-project-from-program-command-result';
import { UpdateProjectCommandResult } from '../models/update-project-command-result';
import { UpdateProjectQuarterCommandResult } from '../models/update-project-quarter-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectGetUserProjectsCardsPost()` */
  static readonly ApiProjectGetUserProjectsCardsPostPath = '/api/Project/GetUserProjectsCards';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetUserProjectsCardsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetUserProjectsCardsPost$Plain$Response(params?: ApiProjectGetUserProjectsCardsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserProjectsCardsQueryResult>> {
    return apiProjectGetUserProjectsCardsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetUserProjectsCardsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetUserProjectsCardsPost$Plain(params?: ApiProjectGetUserProjectsCardsPost$Plain$Params, context?: HttpContext): Observable<GetUserProjectsCardsQueryResult> {
    return this.apiProjectGetUserProjectsCardsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserProjectsCardsQueryResult>): GetUserProjectsCardsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetUserProjectsCardsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetUserProjectsCardsPost$Response(params?: ApiProjectGetUserProjectsCardsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserProjectsCardsQueryResult>> {
    return apiProjectGetUserProjectsCardsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetUserProjectsCardsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetUserProjectsCardsPost(params?: ApiProjectGetUserProjectsCardsPost$Params, context?: HttpContext): Observable<GetUserProjectsCardsQueryResult> {
    return this.apiProjectGetUserProjectsCardsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserProjectsCardsQueryResult>): GetUserProjectsCardsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectGetCurrentUserProjectsPost()` */
  static readonly ApiProjectGetCurrentUserProjectsPostPath = '/api/Project/GetCurrentUserProjects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetCurrentUserProjectsPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectGetCurrentUserProjectsPost$Plain$Response(params?: ApiProjectGetCurrentUserProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserProjectsQueryResult>> {
    return apiProjectGetCurrentUserProjectsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetCurrentUserProjectsPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectGetCurrentUserProjectsPost$Plain(params?: ApiProjectGetCurrentUserProjectsPost$Plain$Params, context?: HttpContext): Observable<GetUserProjectsQueryResult> {
    return this.apiProjectGetCurrentUserProjectsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserProjectsQueryResult>): GetUserProjectsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetCurrentUserProjectsPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectGetCurrentUserProjectsPost$Response(params?: ApiProjectGetCurrentUserProjectsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserProjectsQueryResult>> {
    return apiProjectGetCurrentUserProjectsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetCurrentUserProjectsPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectGetCurrentUserProjectsPost(params?: ApiProjectGetCurrentUserProjectsPost$Params, context?: HttpContext): Observable<GetUserProjectsQueryResult> {
    return this.apiProjectGetCurrentUserProjectsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserProjectsQueryResult>): GetUserProjectsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectGetUserProjectsPost()` */
  static readonly ApiProjectGetUserProjectsPostPath = '/api/Project/GetUserProjects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetUserProjectsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetUserProjectsPost$Plain$Response(params?: ApiProjectGetUserProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserProjectsQueryResult>> {
    return apiProjectGetUserProjectsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetUserProjectsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetUserProjectsPost$Plain(params?: ApiProjectGetUserProjectsPost$Plain$Params, context?: HttpContext): Observable<GetUserProjectsQueryResult> {
    return this.apiProjectGetUserProjectsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserProjectsQueryResult>): GetUserProjectsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetUserProjectsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetUserProjectsPost$Response(params?: ApiProjectGetUserProjectsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserProjectsQueryResult>> {
    return apiProjectGetUserProjectsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetUserProjectsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetUserProjectsPost(params?: ApiProjectGetUserProjectsPost$Params, context?: HttpContext): Observable<GetUserProjectsQueryResult> {
    return this.apiProjectGetUserProjectsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserProjectsQueryResult>): GetUserProjectsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectGetProjectGet()` */
  static readonly ApiProjectGetProjectGetPath = '/api/Project/GetProject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetProjectGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectGetProjectGet$Plain$Response(params: ApiProjectGetProjectGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectQueryResult>> {
    return apiProjectGetProjectGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetProjectGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectGetProjectGet$Plain(params: ApiProjectGetProjectGet$Plain$Params, context?: HttpContext): Observable<GetProjectQueryResult> {
    return this.apiProjectGetProjectGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectQueryResult>): GetProjectQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetProjectGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectGetProjectGet$Response(params: ApiProjectGetProjectGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectQueryResult>> {
    return apiProjectGetProjectGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetProjectGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectGetProjectGet(params: ApiProjectGetProjectGet$Params, context?: HttpContext): Observable<GetProjectQueryResult> {
    return this.apiProjectGetProjectGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectQueryResult>): GetProjectQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectGetAllProjectsPost()` */
  static readonly ApiProjectGetAllProjectsPostPath = '/api/Project/GetAllProjects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetAllProjectsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetAllProjectsPost$Plain$Response(params?: ApiProjectGetAllProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectsQueryResult>> {
    return apiProjectGetAllProjectsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetAllProjectsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetAllProjectsPost$Plain(params?: ApiProjectGetAllProjectsPost$Plain$Params, context?: HttpContext): Observable<GetProjectsQueryResult> {
    return this.apiProjectGetAllProjectsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectsQueryResult>): GetProjectsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetAllProjectsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetAllProjectsPost$Response(params?: ApiProjectGetAllProjectsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectsQueryResult>> {
    return apiProjectGetAllProjectsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetAllProjectsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetAllProjectsPost(params?: ApiProjectGetAllProjectsPost$Params, context?: HttpContext): Observable<GetProjectsQueryResult> {
    return this.apiProjectGetAllProjectsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectsQueryResult>): GetProjectsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectGetNotLaunchedProjectsPost()` */
  static readonly ApiProjectGetNotLaunchedProjectsPostPath = '/api/Project/GetNotLaunchedProjects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetNotLaunchedProjectsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetNotLaunchedProjectsPost$Plain$Response(params?: ApiProjectGetNotLaunchedProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotLaunchedProjectsQueryResult>> {
    return apiProjectGetNotLaunchedProjectsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetNotLaunchedProjectsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetNotLaunchedProjectsPost$Plain(params?: ApiProjectGetNotLaunchedProjectsPost$Plain$Params, context?: HttpContext): Observable<GetNotLaunchedProjectsQueryResult> {
    return this.apiProjectGetNotLaunchedProjectsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetNotLaunchedProjectsQueryResult>): GetNotLaunchedProjectsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetNotLaunchedProjectsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetNotLaunchedProjectsPost$Response(params?: ApiProjectGetNotLaunchedProjectsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotLaunchedProjectsQueryResult>> {
    return apiProjectGetNotLaunchedProjectsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetNotLaunchedProjectsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetNotLaunchedProjectsPost(params?: ApiProjectGetNotLaunchedProjectsPost$Params, context?: HttpContext): Observable<GetNotLaunchedProjectsQueryResult> {
    return this.apiProjectGetNotLaunchedProjectsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetNotLaunchedProjectsQueryResult>): GetNotLaunchedProjectsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectGetLaunchedProjectsPost()` */
  static readonly ApiProjectGetLaunchedProjectsPostPath = '/api/Project/GetLaunchedProjects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetLaunchedProjectsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetLaunchedProjectsPost$Plain$Response(params?: ApiProjectGetLaunchedProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLaunchedProjectsQueryResult>> {
    return apiProjectGetLaunchedProjectsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetLaunchedProjectsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetLaunchedProjectsPost$Plain(params?: ApiProjectGetLaunchedProjectsPost$Plain$Params, context?: HttpContext): Observable<GetLaunchedProjectsQueryResult> {
    return this.apiProjectGetLaunchedProjectsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetLaunchedProjectsQueryResult>): GetLaunchedProjectsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetLaunchedProjectsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetLaunchedProjectsPost$Response(params?: ApiProjectGetLaunchedProjectsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLaunchedProjectsQueryResult>> {
    return apiProjectGetLaunchedProjectsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetLaunchedProjectsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetLaunchedProjectsPost(params?: ApiProjectGetLaunchedProjectsPost$Params, context?: HttpContext): Observable<GetLaunchedProjectsQueryResult> {
    return this.apiProjectGetLaunchedProjectsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetLaunchedProjectsQueryResult>): GetLaunchedProjectsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectGetQuartersPost()` */
  static readonly ApiProjectGetQuartersPostPath = '/api/Project/GetQuarters';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetQuartersPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetQuartersPost$Plain$Response(params?: ApiProjectGetQuartersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetQuartersQueryResult>> {
    return apiProjectGetQuartersPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetQuartersPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetQuartersPost$Plain(params?: ApiProjectGetQuartersPost$Plain$Params, context?: HttpContext): Observable<GetQuartersQueryResult> {
    return this.apiProjectGetQuartersPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetQuartersQueryResult>): GetQuartersQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectGetQuartersPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetQuartersPost$Response(params?: ApiProjectGetQuartersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetQuartersQueryResult>> {
    return apiProjectGetQuartersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectGetQuartersPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectGetQuartersPost(params?: ApiProjectGetQuartersPost$Params, context?: HttpContext): Observable<GetQuartersQueryResult> {
    return this.apiProjectGetQuartersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetQuartersQueryResult>): GetQuartersQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectCreateProjectPost()` */
  static readonly ApiProjectCreateProjectPostPath = '/api/Project/CreateProject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCreateProjectPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectCreateProjectPost$Plain$Response(params?: ApiProjectCreateProjectPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectCommandResult>> {
    return apiProjectCreateProjectPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCreateProjectPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectCreateProjectPost$Plain(params?: ApiProjectCreateProjectPost$Plain$Params, context?: HttpContext): Observable<CreateProjectCommandResult> {
    return this.apiProjectCreateProjectPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectCommandResult>): CreateProjectCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCreateProjectPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectCreateProjectPost$Response(params?: ApiProjectCreateProjectPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectCommandResult>> {
    return apiProjectCreateProjectPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCreateProjectPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectCreateProjectPost(params?: ApiProjectCreateProjectPost$Params, context?: HttpContext): Observable<CreateProjectCommandResult> {
    return this.apiProjectCreateProjectPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectCommandResult>): CreateProjectCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectUpdateProjectPatch()` */
  static readonly ApiProjectUpdateProjectPatchPath = '/api/Project/UpdateProject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectUpdateProjectPatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectUpdateProjectPatch$Plain$Response(params?: ApiProjectUpdateProjectPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectCommandResult>> {
    return apiProjectUpdateProjectPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectUpdateProjectPatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectUpdateProjectPatch$Plain(params?: ApiProjectUpdateProjectPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectCommandResult> {
    return this.apiProjectUpdateProjectPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectCommandResult>): UpdateProjectCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectUpdateProjectPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectUpdateProjectPatch$Response(params?: ApiProjectUpdateProjectPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectCommandResult>> {
    return apiProjectUpdateProjectPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectUpdateProjectPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectUpdateProjectPatch(params?: ApiProjectUpdateProjectPatch$Params, context?: HttpContext): Observable<UpdateProjectCommandResult> {
    return this.apiProjectUpdateProjectPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectCommandResult>): UpdateProjectCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectUpdateProjectQuarterPatch()` */
  static readonly ApiProjectUpdateProjectQuarterPatchPath = '/api/Project/UpdateProjectQuarter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectUpdateProjectQuarterPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectUpdateProjectQuarterPatch$Plain$Response(params?: ApiProjectUpdateProjectQuarterPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectQuarterCommandResult>> {
    return apiProjectUpdateProjectQuarterPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectUpdateProjectQuarterPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectUpdateProjectQuarterPatch$Plain(params?: ApiProjectUpdateProjectQuarterPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectQuarterCommandResult> {
    return this.apiProjectUpdateProjectQuarterPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectQuarterCommandResult>): UpdateProjectQuarterCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectUpdateProjectQuarterPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectUpdateProjectQuarterPatch$Response(params?: ApiProjectUpdateProjectQuarterPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectQuarterCommandResult>> {
    return apiProjectUpdateProjectQuarterPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectUpdateProjectQuarterPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectUpdateProjectQuarterPatch(params?: ApiProjectUpdateProjectQuarterPatch$Params, context?: HttpContext): Observable<UpdateProjectQuarterCommandResult> {
    return this.apiProjectUpdateProjectQuarterPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectQuarterCommandResult>): UpdateProjectQuarterCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectApproveProjectByManagerPatch()` */
  static readonly ApiProjectApproveProjectByManagerPatchPath = '/api/Project/ApproveProjectByManager';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectApproveProjectByManagerPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectByManagerPatch$Plain$Response(params?: ApiProjectApproveProjectByManagerPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectCommandResult>> {
    return apiProjectApproveProjectByManagerPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectApproveProjectByManagerPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectByManagerPatch$Plain(params?: ApiProjectApproveProjectByManagerPatch$Plain$Params, context?: HttpContext): Observable<ApproveProjectCommandResult> {
    return this.apiProjectApproveProjectByManagerPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectCommandResult>): ApproveProjectCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectApproveProjectByManagerPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectByManagerPatch$Response(params?: ApiProjectApproveProjectByManagerPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectCommandResult>> {
    return apiProjectApproveProjectByManagerPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectApproveProjectByManagerPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectByManagerPatch(params?: ApiProjectApproveProjectByManagerPatch$Params, context?: HttpContext): Observable<ApproveProjectCommandResult> {
    return this.apiProjectApproveProjectByManagerPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectCommandResult>): ApproveProjectCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectApproveProjectByConsultativePatch()` */
  static readonly ApiProjectApproveProjectByConsultativePatchPath = '/api/Project/ApproveProjectByConsultative';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectApproveProjectByConsultativePatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectByConsultativePatch$Plain$Response(params?: ApiProjectApproveProjectByConsultativePatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectByConsultativeCommandResult>> {
    return apiProjectApproveProjectByConsultativePatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectApproveProjectByConsultativePatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectByConsultativePatch$Plain(params?: ApiProjectApproveProjectByConsultativePatch$Plain$Params, context?: HttpContext): Observable<ApproveProjectByConsultativeCommandResult> {
    return this.apiProjectApproveProjectByConsultativePatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectByConsultativeCommandResult>): ApproveProjectByConsultativeCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectApproveProjectByConsultativePatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectByConsultativePatch$Response(params?: ApiProjectApproveProjectByConsultativePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectByConsultativeCommandResult>> {
    return apiProjectApproveProjectByConsultativePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectApproveProjectByConsultativePatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectByConsultativePatch(params?: ApiProjectApproveProjectByConsultativePatch$Params, context?: HttpContext): Observable<ApproveProjectByConsultativeCommandResult> {
    return this.apiProjectApproveProjectByConsultativePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectByConsultativeCommandResult>): ApproveProjectByConsultativeCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectApproveProjectItemsPatch()` */
  static readonly ApiProjectApproveProjectItemsPatchPath = '/api/Project/ApproveProjectItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectApproveProjectItemsPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectItemsPatch$Plain$Response(params?: ApiProjectApproveProjectItemsPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectItemsCommandResult>> {
    return apiProjectApproveProjectItemsPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectApproveProjectItemsPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectItemsPatch$Plain(params?: ApiProjectApproveProjectItemsPatch$Plain$Params, context?: HttpContext): Observable<ApproveProjectItemsCommandResult> {
    return this.apiProjectApproveProjectItemsPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectItemsCommandResult>): ApproveProjectItemsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectApproveProjectItemsPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectItemsPatch$Response(params?: ApiProjectApproveProjectItemsPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectItemsCommandResult>> {
    return apiProjectApproveProjectItemsPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectApproveProjectItemsPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectItemsPatch(params?: ApiProjectApproveProjectItemsPatch$Params, context?: HttpContext): Observable<ApproveProjectItemsCommandResult> {
    return this.apiProjectApproveProjectItemsPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectItemsCommandResult>): ApproveProjectItemsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectApproveProjectTasksPatch()` */
  static readonly ApiProjectApproveProjectTasksPatchPath = '/api/Project/ApproveProjectTasks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectApproveProjectTasksPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectTasksPatch$Plain$Response(params?: ApiProjectApproveProjectTasksPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectTasksCommandResult>> {
    return apiProjectApproveProjectTasksPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectApproveProjectTasksPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectTasksPatch$Plain(params?: ApiProjectApproveProjectTasksPatch$Plain$Params, context?: HttpContext): Observable<ApproveProjectTasksCommandResult> {
    return this.apiProjectApproveProjectTasksPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectTasksCommandResult>): ApproveProjectTasksCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectApproveProjectTasksPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectTasksPatch$Response(params?: ApiProjectApproveProjectTasksPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectTasksCommandResult>> {
    return apiProjectApproveProjectTasksPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectApproveProjectTasksPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectApproveProjectTasksPatch(params?: ApiProjectApproveProjectTasksPatch$Params, context?: HttpContext): Observable<ApproveProjectTasksCommandResult> {
    return this.apiProjectApproveProjectTasksPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectTasksCommandResult>): ApproveProjectTasksCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDeleteProjectDelete()` */
  static readonly ApiProjectDeleteProjectDeletePath = '/api/Project/DeleteProject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDeleteProjectDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDeleteProjectDelete$Plain$Response(params?: ApiProjectDeleteProjectDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCommandResult>> {
    return apiProjectDeleteProjectDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDeleteProjectDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDeleteProjectDelete$Plain(params?: ApiProjectDeleteProjectDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectCommandResult> {
    return this.apiProjectDeleteProjectDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectCommandResult>): DeleteProjectCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDeleteProjectDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDeleteProjectDelete$Response(params?: ApiProjectDeleteProjectDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCommandResult>> {
    return apiProjectDeleteProjectDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDeleteProjectDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDeleteProjectDelete(params?: ApiProjectDeleteProjectDelete$Params, context?: HttpContext): Observable<DeleteProjectCommandResult> {
    return this.apiProjectDeleteProjectDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectCommandResult>): DeleteProjectCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectAssignProjectToProgramPost()` */
  static readonly ApiProjectAssignProjectToProgramPostPath = '/api/Project/AssignProjectToProgram';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectAssignProjectToProgramPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectAssignProjectToProgramPost$Plain$Response(params?: ApiProjectAssignProjectToProgramPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignProjectToProgramCommandResult>> {
    return apiProjectAssignProjectToProgramPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectAssignProjectToProgramPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectAssignProjectToProgramPost$Plain(params?: ApiProjectAssignProjectToProgramPost$Plain$Params, context?: HttpContext): Observable<AssignProjectToProgramCommandResult> {
    return this.apiProjectAssignProjectToProgramPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AssignProjectToProgramCommandResult>): AssignProjectToProgramCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectAssignProjectToProgramPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectAssignProjectToProgramPost$Response(params?: ApiProjectAssignProjectToProgramPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignProjectToProgramCommandResult>> {
    return apiProjectAssignProjectToProgramPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectAssignProjectToProgramPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectAssignProjectToProgramPost(params?: ApiProjectAssignProjectToProgramPost$Params, context?: HttpContext): Observable<AssignProjectToProgramCommandResult> {
    return this.apiProjectAssignProjectToProgramPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AssignProjectToProgramCommandResult>): AssignProjectToProgramCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectUnAssignProjectFromProgramPost()` */
  static readonly ApiProjectUnAssignProjectFromProgramPostPath = '/api/Project/UnAssignProjectFromProgram';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectUnAssignProjectFromProgramPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectUnAssignProjectFromProgramPost$Plain$Response(params?: ApiProjectUnAssignProjectFromProgramPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UnAssignProjectFromProgramCommandResult>> {
    return apiProjectUnAssignProjectFromProgramPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectUnAssignProjectFromProgramPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectUnAssignProjectFromProgramPost$Plain(params?: ApiProjectUnAssignProjectFromProgramPost$Plain$Params, context?: HttpContext): Observable<UnAssignProjectFromProgramCommandResult> {
    return this.apiProjectUnAssignProjectFromProgramPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnAssignProjectFromProgramCommandResult>): UnAssignProjectFromProgramCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectUnAssignProjectFromProgramPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectUnAssignProjectFromProgramPost$Response(params?: ApiProjectUnAssignProjectFromProgramPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UnAssignProjectFromProgramCommandResult>> {
    return apiProjectUnAssignProjectFromProgramPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectUnAssignProjectFromProgramPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectUnAssignProjectFromProgramPost(params?: ApiProjectUnAssignProjectFromProgramPost$Params, context?: HttpContext): Observable<UnAssignProjectFromProgramCommandResult> {
    return this.apiProjectUnAssignProjectFromProgramPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnAssignProjectFromProgramCommandResult>): UnAssignProjectFromProgramCommandResult => r.body)
    );
  }

}
